import { HoverPopover } from '@app/components/base/HoverPopover';
import { AuditLiveMention } from '@app/modules/audit/modules/station-audit/types';
import { toTimestamp } from '@mi-front/core';
import { StreamEl } from '@mi-front/ui';
import KeyboardVoiceIcon from '@mui/icons-material/KeyboardVoice';
import { desaturate } from 'polished';
import { MatchMarker } from '../elements';
import { MentionInfo } from './components/MentionInfo';

interface Props {
  readonly liveMention: AuditLiveMention;
}

/**
 * Stream timeline marker for a live mention match, with hover details.
 */
export function AuditMentionMarker({ liveMention }: Props) {
  return (
    <StreamEl
      key={liveMention.datetime}
      ts={toTimestamp(liveMention.datetime)}
      offsetX={-18}
      zIndex={10}
    >
      <HoverPopover
        trigger={
          <MatchMarker color={desaturate(0.2, '#5a5fd3')}>
            <KeyboardVoiceIcon fontSize="small" style={{ marginTop: '-6px' }} />
          </MatchMarker>
        }
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        transformOrigin={{ vertical: 'top', horizontal: 'center' }}
        contentSx={{ p: 0, maxWidth: 'none' }}
        paperSx={{ minWidth: 280, maxWidth: 360 }}
        delay={150}
      >
        <MentionInfo liveMention={liveMention} />
      </HoverPopover>
    </StreamEl>
  );
}
